// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"AccountDetails_themeRoot__2dwjc","accountIcon":"AccountDetails_accountIcon__1rJhm","accountTitleHeader":"AccountDetails_accountTitleHeader__1ipmF"};